import { H1, Li, P, Strong, Ul } from '../Prose';
export default function SectionThirdPartyServices() {
  return (
    <>
      <H1>Third-Party Services</H1>
      <P>
        We use <Strong>Fastmail</Strong> for calendars, all communication with
        clients, and occasionally for inter-team communication if it's useful to
        have an easily searchable email trail.
      </P>

      <P>
        For more informal inter-team communication, we use{' '}
        <Strong>Slack</Strong> (text chat and audio/video chat).
      </P>

      <Ul>
        <Li>
          When chatting in groups, try to always use the "Reply to thread"
          feature (one thread per "topic"), so people can avoid topics not
          relevant to them.
        </Li>
        <Li>
          When chatting in 1:1 messages on the other hand, try to do the
          opposite, and always send direct replies without threading (to avoid
          too many chains of conversation).
        </Li>
      </Ul>

      <P>
        Storage of documents and files related to clients and other company
        matters are on <Strong>Dropbox</Strong>.
      </P>

      <P>
        Our tracking of projects we're currently working on, and how that work
        is divided, is currently via <Strong>Trello</Strong>, although at some
        point in the future we are likely to incorporate that directly into this
        system.
      </P>
    </>
  );
}
